var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 6,
  height: 6,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.31 2.798v.704H3.352V5.46h-.704V3.502H.69v-.704h1.958V.84h.704v1.958H5.31Z",
  fill: "#2C2E3F"
})));
export { SvgPlus as ReactComponent };
export default __webpack_public_path__ + "05c70631dcb3e0f8d8e9aee4566b5729.svg";